/* eslint-disable camelcase */
export default class CustomerOwnedRga {
  id = 0;
  order_no = '';
  app_company_id = '';
  blanket_id = '';
  customer_purchase_order = '';
  partner_id = 0;
  partner_store_id = 0;
  sales_rep_id = 0;
  expected_return_date = '';
  status_id = 0;
  memo = '';
  rma = '';
  partner = {
    name: ''
  };
  status = {
    status: ''
  };
  created_by_name = '';
  partner_store = {
    address_1: '',
    address_2: ''
  };

  constructor (data) {
    Object.assign(this, data)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/_shared/models/CustomerOwnedRga.js